import type { App } from 'vue'
import Rippple from './Ripple'
import Auth from './Auth'
import InputFocus from './InputFocus'
import Draggable from './Draggable'
import ClickOutside from './ClickOutside'
import ResizeOb from './ResizeOb'
import Loading from './Loading'
import TransformShow from './TransformShow'

const directives = [
  Rippple,
  Auth,
  InputFocus,
  Draggable,
  ClickOutside,
  Loading,
  ResizeOb,
  TransformShow,
]

export function setupDirectives(app: App) {
  directives.forEach((directive) => {
    app.directive(directive.name, directive.definition)
  })
}
